import styled from "@emotion/styled";
import { GreenButton } from "../../../../../../../../components/form-controls/button/green-button/green-button.component";
import { BASE_COLORS } from "../../../../../../../../emotion-theme";

export const FormControls = styled.div`
  border: solid 1px ${BASE_COLORS.lightGrey};
  border-radius: 4px;
  padding: 16px;
`;
export const SaveButton = styled(GreenButton)`
  text-align: center;
  margin: 16px auto;
`;
